<template>
    <div class="flex flex-col w-full">
        <label v-if="label" :for="inputId" class="font-bold mb-1">{{ label }}</label>
        <textarea
            :id="inputId"
            v-model="inputValue"
            :rows="rows"
            :name="name"
            :type="type"
            :placeholder="placeholder"
            :class="{ 'border-red-500': error }"
            class="text-input h-full"
            :style="{ resize: showResize }"
            @input="onChange"
        ></textarea>

        <span v-if="error" class="mt-1 text-xs text-italic mt-1 text-red-500">
            {{ error }}
        </span>
    </div>
</template>

<script>
import FormInputsMixin from './form_inputs_mixin';

export default {
    mixins: [FormInputsMixin],

    props: {
        type: {
            type: String,
            default: 'text'
        },
        rows: {
            type: Number,
            default: 3
        },
        showResize: {
            type: String,
            default: 'vertical'
        }
    },

    data() {
        return {
            inputValue: this.value
        };
    },

    watch: {
        value: function() {
            this.inputValue = this.value;
        }
    },

    methods: {
        onChange() {
            this.$emit('input', this.inputValue);
        }
    }
};
</script>
